<div *ngIf="user$ | async as user" class="mt-3 text-black dark:!text-white flex flex-col gap-3">
  <a (click)="navigateBack();" class="text-blue-500 hover:text-blue-400 cursor-pointer">&#8592; Back</a>

  <h4>
    <div class="flex items-center font-bold">Welcome to WHERE<span
        class="text-blue-600 dark:text-blue-300 mr-1">TAKEN</span>.</div>
  </h4>

  <p>
    The aim of the game is to guess what country/region the photo was taken in. <a routerLink="/about"
      class="text-blue-500 hover:text-blue-400 cursor-pointer">Learn more</a>.
  </p>

  <p>
    If you guess incorrectly, the game will tell you how far away you are, and
    displays an arrow e.g. ➡️, that points in the direction of the correct
    country/region.
  </p>

  <p>A new
    <b>WHERE<span class="text-blue-600 dark:text-blue-300">TAKEN</span></b>
    will be available everyday!
  </p>
  <p>Play our new version of
    <b>
      <a class="underline" href="https://wheretaken.com" target="_blank">
        <img class="inline-img inline-block w-6 mr-1 align-middle" ngSrc="./assets/wt-icon.svg" width="72"
          height="72" /><b>Where</b>Taken
      </a>
    </b>
  </p>
  <p>Play our US States version of
    <b>
      <a class="underline" href="https://wheretakenusa.teuteuf.fr" target="_blank">WHERE<span
          class="text-blue-600 dark:text-blue-300">TAKEN🇺🇸</span></a>
    </b>
  </p>
  <hr>
  <p>Made by Ryan and Praveen</p>
  <hr>
  <p class="mb-3">
    You can change your privacy settings by clicking the following
    button:&nbsp;
    <button class="underline cursor-pointer" (click)="manageConsent()">
      Manage Consent
    </button>
  </p>
  <hr>
  <div>
    <a class="underline" href="https://teuteuf.fr/privacy-policy/" target="_blank">Privacy Policy</a> &nbsp;-&nbsp; <a
      class="underline" href="https://teuteuf.notion.site/17eeff4e9f3880e2a6aeef075e74939b?pvs=105"
      target="_blank">Submit Feedback</a>
  </div>
</div>